<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  value?: string | number;
  variant?: 'neutral' | 'primary';
  positionClasses?: string;
}>(), {
  value: 0,
})

const variantClasses = computed(() => {
  if (props.variant === 'primary') {
    return 'bg-primary-500 text-white outline-neutral-200'
  }

  return 'bg-neutral-300 text-grey-900 outline-white'
})

const positionClasses = computed(() => props.positionClasses || '-top-1.5 -right-1.5')
</script>

<template>
  <span
    v-if="value"
    :class="[
      'absolute w-5 h-5 outline z-10 outline-solid overflow-hidden',
      'pointer-events-none flex items-center justify-center font-semibold text-t4 shadow-xs rounded-full',
      variantClasses,
      positionClasses
    ].join(' ')"
  >
    {{ value }}
  </span>
</template>
